import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import App from "./App"
import "./index.css"
import { store } from "./store"
import { ChakraProvider } from "@chakra-ui/react"

const root = ReactDOM.createRoot(document.getElementById("root")!)

root.render(
  <Provider store={store}>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </Provider>
)

// 在正式环境中，控制台不打印日志
const envLevel = process.env.REACT_APP_ENV
if (envLevel === "prod") {
  const noop = () => {}
  // 重写所有 console 方法
  console.log = noop
  console.error = noop
  console.warn = noop
  console.info = noop
  console.debug = noop
}
